export default __webpack_public_path__ + "static/media/gl.a3fd25c7.svg";